import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'error'];

  connect() {
    if (this.hasInputTarget) {
      this.inputTarget.addEventListener('input', this.clearError.bind(this));
    }
  }

  clearError() {
    if (this.hasErrorTarget) {
      this.errorTarget.classList.add('hidden');
    }

    this.inputTarget.classList.remove('field__control--invalid');
  }
};
